module.exports = {"en":{"feedback":"Feedback","bugreport":"Report a bug"},"de":{"feedback":"Rückmeldungen","bugreport":"Fehler melden"},"fr":{"feedback":"Retours","bugreport":"Signaler un bug"},"ru":{"feedback":"Обратная связь","bugreport":"Сообщить о проблемах"},"ja":{"feedback":"Feedback","bugreport":"Report a bug"},"zh":{"feedback":"建议","bugreport":"报告问题"}}


//////////////////
// WEBPACK FOOTER
// ./src/components/SideContainer/side-container.json
// module id = 1204
// module chunks = 0